module.exports = __webpack_public_path__ + "img/user-default.26bf0287.png";